import base from './base';

export const BANNERS = { ...base.BANNERS };
export const PAYMENTS = { ...base.PAYMENTS };
export const ERRORS = { ...base.ERRORS };
export const WARNINGS = { ...base.WARNINGS };
